export default __webpack_public_path__ + "static/media/logo.d4004ad5.png";